// Stockage du token admin.
// Même stratégie que l'app atelier : mémoire primaire + sessionStorage secondaire.
// Les clés sont préfixées "admin_" pour éviter tout conflit si le même navigateur
// accède aux deux apps (peu probable sur des sous-domaines différents mais explicite).
import { Injectable } from '@angular/core';

const TOKEN_KEY = 'admin_token';

@Injectable({ providedIn: 'root' })
export class AdminAuthStorageService {
  private _token: string | null = null;

  constructor() {
    this._token = sessionStorage.getItem(TOKEN_KEY);
  }

  getToken(): string | null { return this._token; }
  hasToken(): boolean { return !!this._token; }

  setToken(token: string): void {
    this._token = token;
    sessionStorage.setItem(TOKEN_KEY, token);
  }

  clear(): void {
    this._token = null;
    sessionStorage.removeItem(TOKEN_KEY);
  }
}
